import { render, staticRenderFns } from "./InstanceDetail.vue?vue&type=template&id=157fa6ea&scoped=true&"
import script from "./InstanceDetail.vue?vue&type=script&lang=js&"
export * from "./InstanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./InstanceDetail.vue?vue&type=style&index=0&id=157fa6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157fa6ea",
  null
  
)

export default component.exports